export { default } from './Clipboard'
